'use strict';
/**
 * Exception raised when trying to revert migration that is not possible
 * to revert.
 */

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var NonReversibleMigrationError = /*#__PURE__*/function (_Error) {
  _inherits(NonReversibleMigrationError, _Error);

  var _super = _createSuper(NonReversibleMigrationError);

  function NonReversibleMigrationError(message) {
    var _this;

    _classCallCheck(this, NonReversibleMigrationError);

    _this = _super.call(this, message);
    _this.name = 'NonReversibleMigrationError';
    _this.code = 'ERR_NON_REVERSIBLE_MIGRATION';
    _this.message = message;
    return _this;
  }

  return NonReversibleMigrationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

NonReversibleMigrationError.code = 'ERR_NON_REVERSIBLE_MIGRATION';
exports.NonReversibleMigrationError = NonReversibleMigrationError;
/**
 * Exception raised when repo is not initialized.
 */

var NotInitializedRepoError = /*#__PURE__*/function (_Error2) {
  _inherits(NotInitializedRepoError, _Error2);

  var _super2 = _createSuper(NotInitializedRepoError);

  function NotInitializedRepoError(message) {
    var _this2;

    _classCallCheck(this, NotInitializedRepoError);

    _this2 = _super2.call(this, message);
    _this2.name = 'NotInitializedRepoError';
    _this2.code = 'ERR_NOT_INITIALIZED_REPO';
    _this2.message = message;
    return _this2;
  }

  return NotInitializedRepoError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

NotInitializedRepoError.code = 'ERR_NOT_INITIALIZED_REPO';
exports.NotInitializedRepoError = NotInitializedRepoError;
/**
 * Exception raised when required parameter is not provided.
 */

var RequiredParameterError = /*#__PURE__*/function (_Error3) {
  _inherits(RequiredParameterError, _Error3);

  var _super3 = _createSuper(RequiredParameterError);

  function RequiredParameterError(message) {
    var _this3;

    _classCallCheck(this, RequiredParameterError);

    _this3 = _super3.call(this, message);
    _this3.name = 'RequiredParameterError';
    _this3.code = 'ERR_REQUIRED_PARAMETER';
    _this3.message = message;
    return _this3;
  }

  return RequiredParameterError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

RequiredParameterError.code = 'ERR_REQUIRED_PARAMETER';
exports.RequiredParameterError = RequiredParameterError;
/**
 * Exception raised when value is not valid.
 */

var InvalidValueError = /*#__PURE__*/function (_Error4) {
  _inherits(InvalidValueError, _Error4);

  var _super4 = _createSuper(InvalidValueError);

  function InvalidValueError(message) {
    var _this4;

    _classCallCheck(this, InvalidValueError);

    _this4 = _super4.call(this, message);
    _this4.name = 'InvalidValueError';
    _this4.code = 'ERR_INVALID_VALUE';
    _this4.message = message;
    return _this4;
  }

  return InvalidValueError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

InvalidValueError.code = 'ERR_INVALID_VALUE';
exports.InvalidValueError = InvalidValueError;